<template>
    <div>
        <table style="width: 90%; margin: 0 5%; margin-top: 20px;">
            <tr>
                <td style="height: 30px; width: 25%;">
                    <el-row>
                        <el-col :span="12" style="text-align: right; color: #a1a1a1; line-height: 30px;">社保编号：</el-col>
                        <el-col :span="12" style="line-height: 30px;">{{from.social_security_no}}</el-col>
                    </el-row>
                </td>
                <td style="width: 25%;">
                    <el-row>
                        <el-col :span="12" style="text-align: right; color: #a1a1a1; line-height: 30px;">医保编号：</el-col>
                        <el-col :span="12" style="line-height: 30px;">{{from.medical_insurance_no}}</el-col>
                    </el-row>
                </td>
                <td style="width: 25%;">
                    <el-row>
                        <el-col :span="12" style="text-align: right; color: #a1a1a1; line-height: 30px;">保险类别：</el-col>
                        <el-col :span="12" style="line-height: 30px;">{{from.insurance_type}}</el-col>
                    </el-row>
                </td>
                <td style="width: 25%;">
                    <el-row>
                        <el-col :span="12" style="text-align: right; color: #a1a1a1; line-height: 30px;">五险参保开始月份：
                        </el-col>
                        <el-col :span="12" style="line-height: 30px;">{{from.insured_begin_date}}</el-col>
                    </el-row>
                </td>
            </tr>

            <tr>
                <td style="height: 30px;">
                    <el-row>
                        <el-col :span="12" style="text-align: right; color: #a1a1a1; line-height: 30px;">缴纳社保城市：
                        </el-col>
                        <el-col :span="12" style="line-height: 30px;">{{from.insured_city}}</el-col>
                    </el-row>
                </td>
                <td>
                    <el-row>
                        <el-col :span="12" style="text-align: right; color: #a1a1a1; line-height: 30px;">缴费基数：
                        </el-col>
                        <el-col :span="12" style="line-height: 30px;">{{from.payment_type}}</el-col>
                    </el-row>
                </td>
                <td>
                    <el-row>
                        <el-col :span="12" style="text-align: right; color: #a1a1a1; line-height: 30px;">雇主出险记录：
                        </el-col>
                        <el-col :span="12" style="line-height: 30px;">
                            <el-button plain size="mini" @click="dangerStatus">出险记录</el-button>
                        </el-col>
                    </el-row>
                </td>
                <td>
                    <el-row>
                        <el-col :span="12" style="text-align: right; color: #a1a1a1; line-height: 30px;">雇主出险状态：
                        </el-col>
                        <el-col :span="12" style="line-height: 30px;">{{from.entry_type}}</el-col>
                    </el-row>
                </td>
            </tr>

            <tr>
                <td style="height: 30px;">
                    <el-row>
                        <el-col :span="12" style="text-align: right; color: #a1a1a1; line-height: 30px;">是否缴纳公积金：
                        </el-col>
                        <el-col :span="12" style="line-height: 30px;">{{from.is_accumulation_fund_title}}</el-col>
                    </el-row>
                </td>
                <td>
                    <el-row>
                        <el-col :span="12" style="text-align: right; color: #a1a1a1; line-height: 30px;">公积金编号：
                        </el-col>
                        <el-col :span="12" style="line-height: 30px;">{{from.accumulation_fund_no}}</el-col>
                    </el-row>
                </td>
                <td>
                    <el-row>
                        <el-col :span="12" style="text-align: right; color: #a1a1a1; line-height: 30px;">公积金基数：
                        </el-col>
                        <el-col :span="12" style="line-height: 30px;">{{from.provident_fund_base}}</el-col>
                    </el-row>
                </td>
                <td> 
                    <el-row>
                        <el-col :span="12" style="text-align: right; color: #a1a1a1; line-height: 30px;">缴纳账户：
                        </el-col>
                        <el-col :span="12" style="line-height: 30px;">{{from.payment_account_name}}</el-col>
                    </el-row>
                </td>
            </tr>

            <tr>
                <td style="height: 30px;">
                    <el-row>
                        <el-col :span="12" style="text-align: right; color: #a1a1a1; line-height: 30px;">五险缴纳账户：
                        </el-col>
                        <el-col :span="12" style="line-height: 30px;">{{from.five_risks_account_name}}</el-col>
                    </el-row>
                </td>
                <td>
                    <el-row>
                        <el-col :span="12" style="text-align: right; color: #a1a1a1; line-height: 30px;">养老三险基数：
                        </el-col>
                        <el-col :span="12" style="line-height: 30px;">{{from.aged_three_insurance}}</el-col>
                    </el-row>
                </td>
                <td>
                    <el-row>
                        <el-col :span="12" style="text-align: right; color: #a1a1a1; line-height: 30px;">生育医疗保险基数：
                        </el-col>
                        <el-col :span="12" style="line-height: 30px;">{{from.birth_insurance}}</el-col>
                    </el-row>
                </td>
                <td>
                    <el-row>
                        <el-col :span="14" style="text-align: right; color: #a1a1a1; line-height: 30px;">是否扣医保大额：
                        </el-col>
                        <el-col :span="10" style="line-height: 30px;">{{from.is_insurance_medical}}</el-col>
                    </el-row>
                </td>
            </tr>

            <tr>
                <td style="height: 30px;">
                    <el-row>
                        <el-col :span="12" style="text-align: right; color: #a1a1a1; line-height: 30px;">五险补差数额：
                        </el-col>
                        <el-col :span="12" style="line-height: 30px;">{{from.amount_making_difference}}</el-col>
                    </el-row>
                </td>
                <td>
                    <el-row>
                        <el-col :span="12" style="text-align: right; color: #a1a1a1; line-height: 30px;">补差日期：
                        </el-col>
                        <el-col :span="12" style="line-height: 30px;">{{from.variance_makeup_date}}</el-col>
                    </el-row>
                </td>
                <td></td>
                <td></td>
            </tr>
            
            <el-dialog :title="出险记录" :visible.sync="dangerStatusType"
				width="30%" center="true" :close-on-click-modal="false">
                <el-table ref="multipleTable" :header-cell-style="{background:'#F0F0F0',color:'#000000'}"
                        :data="danger" tooltip-effect="dark" style="width: 100%" height="300">
                    <el-table-column label="序号" width="50">
                        <template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
                    </el-table-column>
                    <el-table-column prop="danger_dete" label="出险时间" align="center"></el-table-column>
                    <el-table-column prop="settlement_status" label="理赔情况" align="center"></el-table-column>
                </el-table>
                <div style="text-align: center;margin-top: 10px;">
                    <el-button style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;" @click="dangerSavesp()">关闭</el-button>
                </div>
            </el-dialog>
        </table>
    </div>
</template>

<script>
    export default {
        props: ["from"],
        data() {
            return {
                dangerStatusType:false,
                danger:[],

            }
        },
        methods:{
            async dangerStatus(){
                debugger
                var url = "Danger/selectStaffAlls?staff_id=" + this.from.id;
				var data = await this.$globals.AxiosGet(url);
                
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.danger = data;
						this.dangerStatusType = true
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
            },

            dangerSavesp(){
                this.dangerStatusType = false;
                this.danger = [];
            }

        },
    }
</script>

<style scoped="scoped">
    >>>.el-button {
        border: 1px solid #006e48;
        color: #006e48;
    }

    >>>.el-button:hover {
        border: 1px solid #006e48;
        color: #006e48;
    }
</style>



// WEBPACK FOOTER //
// insurance.vue?480be0ee